import React, { useRef, useState } from "react";
import {
    Paging,
    Pager,
    FilterRow,
    ColumnChooser,
    Column,
    Lookup,
    Export,
    Summary,
    TotalItem,
    Editing,
    Button as ButtonGrid
}
    from 'devextreme-react/data-grid';
import { DataGrid } from 'devextreme-react';
import Title from "../../components/shared/Title";
import { store } from "../../services/store";
import { formatDate, formatDateTime } from '../../data/app';
import { useDispatch } from 'react-redux';
import { cellAsPayoff, cellRender, cellRenderBold, dataFormatId } from "../../utils/common";
import numeral from "numeral";
import { dialogPayment } from '../../store/payment/paymentDialogReducer';

import { createStoreLocal } from "../../utils/proxy";
import Payments from "./Payments";

const PurchasePending = props => {

    let refGrid = useRef();
    const dispatch = useDispatch();

    const showDialog = (id) => dispatch(dialogPayment({ open: true, id }));

    const onCellPrepared = e => {

        const cellsQuantity = ['payoff']

        if (e.rowType == 'data' && e.column.allowEditing) {
            if (cellsQuantity.includes(e.column.dataField))
                if (e.row.data.payoff)
                    e.cellElement.classList.add('pagada');
                else
                    e.cellElement.classList.add('pendiente');

            if (e.column.dataField == 'id')
                e.cellElement.classList.add('col-id-factura');
            // if (e.column.dataField == 'reference')
            //     e.cellElement.classList.add('col-reference-factura');
            if (e.column.dataField == 'mora')
                if (e.row.data.mora < 0)
                    e.cellElement.classList.add('col-mora');
        }

    }

    const title = "Cuentas por cobrar";

    const customizeText = (cellInfo) => {
        return `$ ${numeral(cellInfo.value).format('0,0.00')}`
    }



    const onSave = (e) => refGrid.current.instance.refresh();

    return (
        <div className="container">
            <Title title={title} />
            <Payments {...props} onSave={onSave} />
            <DataGrid
                ref={refGrid}
                dataSource={store({ uri: { get: 'purchases/pending/get' } })}
                selection={{ mode: 'single' }}
                showBorders={true}
                showRowLines={true}
                allowColumnResizing={true}
                columnHidingEnabled={true}
                allowColumnReordering={true}
                hoverStateEnabled={true}
                columnAutoWidth={true}
                onCellPrepared={onCellPrepared}
            >
                <Pager allowedPageSizes={[10, 15, 30, 50]} showPageSizeSelector={true} showInfo={true} />
                <Paging defaultPageSize={15} />
                <FilterRow visible={true} />
                <ColumnChooser enabled={true} />
                <Export enabled={true} fileName={title} allowExportSelectedData={true} />
                <Column type="buttons" width={90} caption={'Acciones'}>
                    <ButtonGrid name="edit" icon="money" text={'Pagar'} onClick={e => showDialog(e.row.data.id)} />
                </Column>
                <Column dataField="id" caption='Numero' width={100} cellRender={dataFormatId} />
                <Column dataField="date" caption='Fecha' dataType='date' format={formatDate} width={90} />
                <Column dataField="providerName" caption="Proveedor" minWidth={120}></Column>
                <Column dataField="reference" caption='Referencia' width={100} />
                <Column dataField="total" width={110} cellRender={cellRender()} />
                <Column dataField="amount" caption='Pagado' width={110} cellRender={cellRender()} />
                <Column dataField="balance" caption='Saldo' width={110} cellRender={cellRenderBold()} />
                <Column dataField="expireAt" caption='Vence' width={90} cellRender={e => {
                    console.log(e.data);
                    return <span>{e.data.expireAt < 0 ? 'Vencido' : parseInt(e.data.expireAt) + ' días'}</span>;
                }} />

                <Column dataField="purchaseTypeId" caption="Tipo Compra" width={90}>
                    <Lookup disabled={true} dataSource={createStoreLocal({ name: 'purchaseType' })} valueExpr="id" displayExpr="name" />
                </Column>
                <Column dataField="payoff" width={100} caption='Pagada' dataType="boolean" cellRender={cellAsPayoff} />
                <Column dataField="observation" caption='Observacion' visible={false} allowHeaderFiltering={false} allowFiltering={false} />
                <Column dataField="createAt" caption='Creado el' dataType='date' format={formatDateTime} width={180} />
                <Column dataField="createBy" caption='Creado Por' width={120} />

                <Summary>
                    <TotalItem column="total" summaryType="sum" customizeText={customizeText} />
                    <TotalItem column="amount" summaryType="sum" customizeText={customizeText} />
                    <TotalItem column="balance" summaryType="sum" customizeText={customizeText} />
                </Summary>
                <Editing
                    mode="popup"
                    allowDeleting={true}
                    allowUpdating={true}
                    useIcons={true}
                >
                </Editing>
            </DataGrid>
        </div>
    )


}


export default PurchasePending;
